import styled from 'styled-components';
import { useScene } from '../../../context/sceneContext';
import { useUIStore } from '../../../hooks/stores/uiStore';

export const SimulationPanel = () => {
  const scene = useScene();
  const [UIData] = useUIStore();

  return (
    <Container>
      {UIData.currentStateView === 'stateViewNotInstalled' && (
        <>
          <Item onClick={() => scene.executeCommand({ type: 'startAppInstallTaskCommand' })}>Install</Item>
        </>
      )}
      {UIData.currentStateView === 'stateViewInstalled' && (
        <>
          <Item onClick={() => scene.executeCommand({ type: 'startAppCommand' })}>Run app</Item>
          <Item onClick={() => scene.setLauncherView('stateViewUpdateAvailable')}>
            Release update
          </Item>
          <Item onClick={() => scene.setLauncherView('stateViewNeedRepair')}>
            Corrupt files
          </Item>
          <Item onClick={() => scene.setLauncherView('stateViewMoveInProgress')}>
            Move app
          </Item>
          <Item onClick={() => scene.setLauncherView('stateViewUninstallationInProgress')}>
            Uninstall
          </Item>
        </>
      )}
      {UIData.currentStateView === 'stateViewUpdateAvailable' && (
        <Item onClick={() => scene.setLauncherView('stateViewUpdateInProgress')}>Update</Item>
      )}
      {UIData.currentStateView === 'stateViewNeedRepair' && (
        <Item onClick={() => scene.setLauncherView('stateViewRepairInProgress')}>Repair</Item>
      )}
      {UIData.currentStateView === 'stateViewInstallationInProgress' && (
        <>
          <Item onClick={() => scene.setLauncherView('stateViewInstalled')}>
            Finish installation
          </Item>
          <Item onClick={() => scene.setLauncherView('stateViewInstallationPaused')}>
            Pause installation
          </Item>
          <Item onClick={() => scene.setLauncherView('stateViewInstallationFailed')}>
            Fail installation
          </Item>
        </>
      )}
      {UIData.currentStateView === 'stateViewRunning' && (
        <Item onClick={() => scene.setLauncherView('stateViewInstalled')}>Close app</Item>
      )}
      {UIData.currentStateView === 'stateViewUpdateInProgress' && (
        <>
          <Item onClick={() => scene.setLauncherView('stateViewInstalled')}>
            Finish updating
          </Item>
          <Item onClick={() => scene.setLauncherView('stateViewUpdatePaused')}>
            Pause updating
          </Item>
          <Item onClick={() => scene.setLauncherView('stateViewUpdateFailed')}>
            Fail updating
          </Item>
        </>
      )}
      {UIData.currentStateView === 'stateViewRepairInProgress' && (
        <>
          <Item onClick={() => scene.setLauncherView('stateViewInstalled')}>
            Finish repairing
          </Item>
          <Item onClick={() => scene.setLauncherView('stateViewRepairPaused')}>
            Pause repairing
          </Item>
          <Item onClick={() => scene.setLauncherView('stateViewRepairFailed')}>
            Fail repairing
          </Item>
        </>
      )}
      {UIData.currentStateView === 'stateViewMoveInProgress' && (
        <>
          <Item onClick={() => scene.setLauncherView('stateViewInstalled')}>
            Finish moving
          </Item>
          <Item onClick={() => scene.setLauncherView('stateViewMoveFailed')}>
            Fail moving
          </Item>
        </>
      )}
      {UIData.currentStateView === 'stateViewUninstallationInProgress' && (
        <>
          <Item onClick={() => scene.setLauncherView('stateViewNotInstalled')}>
            Finish uninstallation
          </Item>
          <Item onClick={() => scene.setLauncherView('stateViewUninstallationFailed')}>
            Fail uninstallation
          </Item>
        </>
      )}
      {UIData.currentStateView === 'stateViewInstallationFailed' && (
        <Item onClick={() => scene.setLauncherView('stateViewNotInstalled')}>
          Reject installation error
        </Item>
      )}
      {UIData.currentStateView === 'stateViewMoveFailed' && (
        <Item onClick={() => scene.setLauncherView('stateViewInstalled')}>
          Reject moving error
        </Item>
      )}
      {UIData.currentStateView === 'stateViewRepairFailed' && (
        <Item onClick={() => scene.setLauncherView('stateViewNeedRepair')}>
          Reject repairing error
        </Item>
      )}
      {UIData.currentStateView === 'stateViewUpdateFailed' && (
        <Item onClick={() => scene.setLauncherView('stateViewUpdateAvailable')}>
          Reject updating error
        </Item>
      )}
      {UIData.currentStateView === 'stateViewUninstallationFailed' && (
        <Item onClick={() => scene.setLauncherView('stateViewInstalled')}>
          Reject uninstallation error
        </Item>
      )}
      {UIData.currentStateView === 'stateViewInstallationPaused' && (
        <Item onClick={() => scene.setLauncherView('stateViewInstallationInProgress')}>
          Resume installation
        </Item>
      )}
      {UIData.currentStateView === 'stateViewRepairPaused' && (
        <Item onClick={() => scene.setLauncherView('stateViewRepairInProgress')}>
          Resume repairing
        </Item>
      )}
      {UIData.currentStateView === 'stateViewUpdatePaused' && (
        <Item onClick={() => scene.setLauncherView('stateViewUpdateInProgress')}>
          Resume updating
        </Item>
      )}
    </Container>
  );
};

const Container = styled.div`
  min-width: 150px;
  padding: 5px;

  font-family: var(--font-1);
  font-size: 12px;

  display: flex;
  flex-direction: column;
`;

const Item = styled.div`
  cursor: pointer;
  padding: 5px 10px;
  white-space: nowrap;

  display: flex;
  justify-content: space-between;

  background-color: var(--neutral-2);
  color: var(--main-2);
  border-radius: var(--radius-2);

  transition:
    background-color 0.3s ease,
    color 0.3s ease;

  &:hover {
    background-color: var(--neutral-3);
    color: var(--main-1);
  }
`;
